import React from "react";
import "../CSS_folder/ProjectCard.css";
import {
  Fade,
  Flip,
  Bounce,
  JackInTheBox,
  Rotate,
  Roll,
  Slide,
  Zoom,
} from "react-awesome-reveal";


const ProjectCard = ({ project }) => {
  const { title, description, image, url, tag } = project;

  const openUrlInNewTab = () => {
    window.open(url, "_blank");
  };

  return (
    <div className="projectCard">
      <div className="projectContentWrapper">
        <div
          className="projectImage"
          id="project"
          onClick={openUrlInNewTab}
          style={{ cursor: "pointer" }}
        >
          <img src={image} alt={title} />
        </div>

        <div className="projectDescription">
          <Fade delay={900}>
            <h3>{title}</h3>
          </Fade>
          <Fade delay={1100}>
            <p onClick={openUrlInNewTab} className="findMoreButton">
              Learn More
            </p>
          </Fade>

          <Fade delay={1300}>
            <p>{description}</p>
          </Fade>
          <Fade delay={1500}>
            <div className="tagGroup">
              {tag.map((tagItem, index) => (
                <div key={index} className="tag">
                  {tagItem}
                </div>
              ))}
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
